import { useEffect } from 'react';
import { io } from "socket.io-client";
import "./styles/socket.css"

export default function Socket() {
    var socket = io("https://shopxyz.online/");

    useEffect(()=>{
        var messages = document.getElementById('messages');
        var form = document.getElementById('form');
        var input = document.getElementById('input');
    
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          if (input.value) {
            socket.emit('chat message', input.value);
            input.value = '';
          }
        });
    
        socket.on('chat message', function(msg) {
          var item = document.createElement('li');
          item.textContent = msg;
          messages.appendChild(item);
          window.scrollTo(0, document.body.scrollHeight);
        });
    })

  return(
    <div className="socket">
        <ul id="messages"></ul>
        <form id="form" action="">
          <input id="input" />
          <button>送出</button>
        </form>
    </div>
  )
}